exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.category-desc[data-v-1d89371a] {\n  color: #343434;\n}\n.category-desc[data-v-1d89371a] p {\n  font-size: 14px;\n  line-height: 20px;\n}\n", ""]);

// exports
